export default __webpack_public_path__ + "static/media/Keramikboden.f3ca1c91.jpg";